import styled from 'styled-components';

export const Button = styled.button.attrs(() => ({
  className: 'hoverable',
}))`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${({ $icon }) => $icon ? '8px 24px' : '8px 15px'};
  background-color: ${({ $primary, $bgColor }) => ($primary ? $bgColor : 'transparent')};
  color: ${({ $primary, $color, $bgColor }) => ($primary ? $color : $bgColor)};
  border: 1px solid ${({ $bColor }) => $bColor};
  border-radius: 4px;
  cursor: pointer;
  outline-color: ${({ $bgColor }) => $bgColor};
  font-size: 14px;
  line-height: 20px;
  font-weight: 600;
  height: 36px;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;
